import React, { useState } from "react";
import {
  Button,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import Drawer from "@mui/material/Drawer";
import { useNavigate } from "react-router-dom";
import SearchModal from "../../../Shared/Search";
import WishlistButton from "../../../Shared/WishlistButton";
import Checkout from "../../Checkout";
import { ArrowBack, Close } from "@mui/icons-material";
import { myAddressList } from "../../../Services/Address/AddressList";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useFormik } from "formik";
import { addAddressFn } from "../../../Services/Address/AddAddress";
import { stateListFn } from "../../../Services/Address/State";
import { cityListFn } from "../../../Services/Address/City";
import { countryListFn } from "../../../Services/Address/Country";
import { addAddressSchema } from "../../../Schemas";

const MyBillingDetails = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const client = useQueryClient();
  const { data: addressList } = useQuery(
    ["myAddressList"],
    () => myAddressList(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  const { mutate: addAddress } = useMutation(addAddressFn, {
    onSuccess: (res) => {
      console.log(res.data);
      client.refetchQueries("myAddressList");
      setOpen(false);
    },
  });
  const initialValues = {
    address_type: "",
    area: "",
    street_address: "",
    city_id: "",
    state_id: "",
    country_id: "",
    pincode: "",
    email: "",
    mobile_number: "",
    address: "",
  };
  const { handleBlur, handleChange, handleSubmit, values, touched, errors } =
    useFormik({
      initialValues: initialValues,
      validationSchema: addAddressSchema,
      onSubmit: () => {
        const reqBody = {
          address_type: values.address_type,
          address: values.address,
          area: values.area,
          street_address: values.street_address,
          city_id: values.city_id,
          state_id: values.state_id,
          country_id: values.country_id,
          pincode: values.pincode,
          email: values.email,
          mobile_number: values.mobile_number,
        };
        addAddress(reqBody);
      },
    });
  const { data: country } = useQuery(
    ["country", open],
    () => open && countryListFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  const { data: state } = useQuery(
    ["state", values.country_id],
    () => values.country_id && stateListFn({ country_id: values.country_id }),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  const { data: city } = useQuery(
    ["city", values.state_id],
    () => values.state_id && cityListFn({ state_id: values.state_id }),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  return (
    <>
      <div className="py-4 px-3 shadow h-16 fixed top-0 z-50 bg-white dark:bg-zinc-900 w-full flex justify-between gap-4">
        <span className="flex gap-5 items-center">
          <ArrowBack onClick={() => navigate(-1)} />
          <p className="text-xl">My Billing Address</p>
        </span>
        <span className="flex gap-5 items-center ">
          <SearchModal />
          <WishlistButton /> <Checkout />
        </span>
      </div>

      <div className="px-2 py-[75px]">
        <div className="border-t-8 flex flex-col gap-4 p-2 bg-white dark:bg-zinc-800 border-green-500 shadow shadow-zinc-400 dark:shadow-zinc-900 rounded">
          <div className="flex flex-col gap-2 min-h-[72vh]">
            {addressList?.data?.data?.my_address_list?.map((address, index) => {
              return (
                <div
                  key={index + 1}
                  className="flex flex-col shadow shadow-zinc-400 dark:shadow-zinc-900 p-4 !rounded"
                >
                  <span className="flex justify-between">
                    <p className="font-bold">{address.address_type}</p>
                  </span>
                  <p>
                    {address.first_name} {address.last_name}
                  </p>
                  <span className="flex justify-between items-end">
                    <p>
                      {address.address}, {address.area},{" "}
                      {address.street_address}, {address.city}, {address.state},{" "}
                      {address.country}, {address.pincode}
                    </p>
                    {/* {addressId === address.id ? (
                      <Edit
                        fontSize="small"
                        color="warning"
                        // onClick={() => handleUpdate(Number(address?.id))}
                      />
                    ) : null} */}
                  </span>
                </div>
              );
            })}
            <Button
              disableElevation
              variant="contained"
              onClick={() => setOpen(true)}
            >
              Add Billing Address
            </Button>
          </div>

          {addressList?.data?.data?.my_address_list?.length === 0 && (
            <span className="px-3 py-4">
              <p className="py-2">Welcome</p>
              <p className="font-bold py-2">
                Lets get started with adding your bank account.
              </p>
              <p className="py-2">
                This account will be used for all kinds of payments, i.e.
                commissions and bonus.
              </p>
            </span>
          )}

          <Drawer
            anchor="bottom"
            open={open}
            onClose={() => setOpen(false)}
            PaperProps={{ className: "!rounded-t-lg" }}
          >
            <form
              onSubmit={handleSubmit}
              className="p-6 flex flex-col justify-center items-center"
            >
              <span className="flex justify-center">
                <p className="text-xl font-semibold text-center py-5">
                  Add Delivery Address
                </p>
                <span className="relative w-0 bottom-2 left-8">
                  <Close
                    className="!text-4xl p-px border-2 !rounded"
                    onClick={() => setOpen(false)}
                  />
                </span>
              </span>
              <div className="grid lg:grid-cols-2 gap-5 overflow-y-auto lg:pr-0 pr-1 w-full">
                <span className="w-full">
                  <p>Address Type*</p>
                  <FormControl fullWidth>
                    <Select
                      id="address_type"
                      name="address_type"
                      color="warning"
                      value={values["address_type"]}
                      size="small"
                      className="!w-full"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      FormHelperTextProps={{ className: "!text-red-500" }}
                      error={
                        errors["address_type"] && touched["address_type"]
                          ? true
                          : false
                      }
                      helperText={
                        touched["address_type"] && errors["address_type"]
                      }
                    >
                      <MenuItem value={"Home"}>Home</MenuItem>
                      <MenuItem value={"Office"}>Office</MenuItem>
                      <MenuItem value={"Other"}>Other</MenuItem>
                    </Select>
                  </FormControl>
                </span>
                <span className="w-full">
                  <p>Contact Number*</p>
                  <TextField
                    type="number"
                    onBlur={handleBlur}
                    color="warning"
                    className="!w-full !rounded"
                    id="mobile_number"
                    name="mobile_number"
                    value={values["mobile_number"]}
                    size="small"
                    onChange={handleChange}
                    error={
                      errors["mobile_number"] && touched["mobile_number"]
                        ? true
                        : false
                    }
                    helperText={
                      touched["mobile_number"] && errors["mobile_number"]
                    }
                    FormHelperTextProps={{ className: "!text-red-500" }}
                  />
                </span>
                <span className="w-full">
                  <p>Flat/House No./Compnay Name*</p>
                  <TextField
                    type="text"
                    onBlur={handleBlur}
                    color="warning"
                    id="address"
                    name="address"
                    value={values["address"]}
                    size="small"
                    onChange={handleChange}
                    className="!w-full !rounded"
                    error={
                      errors["address"] && touched["address"] ? true : false
                    }
                    helperText={touched["address"] && errors["address"]}
                    FormHelperTextProps={{ className: "!text-red-500" }}
                  />
                </span>
                <span className="w-full">
                  <p>Area/Landmark*</p>
                  <TextField
                    type="text"
                    onBlur={handleBlur}
                    color="warning"
                    id="area"
                    name="area"
                    value={values["area"]}
                    size="small"
                    onChange={handleChange}
                    className="!w-full !rounded"
                    error={errors["area"] && touched["area"] ? true : false}
                    helperText={touched["area"] && errors["area"]}
                    FormHelperTextProps={{ className: "!text-red-500" }}
                  />
                </span>

                <span className="w-full">
                  <p>Street/Sector/Village*</p>
                  <TextField
                    type="text"
                    onBlur={handleBlur}
                    color="warning"
                    id="street_address"
                    name="street_address"
                    value={values["street_address"]}
                    size="small"
                    onChange={handleChange}
                    className="!w-full !rounded"
                    error={
                      errors["street_address"] && touched["street_address"]
                        ? true
                        : false
                    }
                    helperText={
                      touched["street_address"] && errors["street_address"]
                    }
                    FormHelperTextProps={{ className: "!text-red-500" }}
                  />
                </span>
                <span className="w-full">
                  <p>Pincode*</p>
                  <TextField
                    type="number"
                    onBlur={handleBlur}
                    color="warning"
                    id="pincode"
                    name="pincode"
                    value={values["pincode"]}
                    size="small"
                    onChange={handleChange}
                    className="!w-full !rounded"
                    error={
                      errors["pincode"] && touched["pincode"] ? true : false
                    }
                    helperText={touched["pincode"] && errors["pincode"]}
                    FormHelperTextProps={{ className: "!text-red-500" }}
                  />
                </span>
                <span className="w-full">
                  <p>Email*</p>
                  <TextField
                    type="text"
                    onBlur={handleBlur}
                    color="warning"
                    className="!w-full !rounded"
                    id="email"
                    name="email"
                    value={values["email"]}
                    size="small"
                    onChange={handleChange}
                    error={errors["email"] && touched["email"] ? true : false}
                    helperText={touched["email"] && errors["email"]}
                    FormHelperTextProps={{ className: "!text-red-500" }}
                  />
                </span>

                <span className="w-full">
                  <p>Country*</p>
                  <FormControl fullWidth>
                    <Select
                      id="country_id"
                      onBlur={handleBlur}
                      color="warning"
                      name="country_id"
                      value={values["country_id"]}
                      size="small"
                      className="!w-full"
                      onChange={handleChange}
                      error={
                        errors["country_id"] && touched["country_id"]
                          ? true
                          : false
                      }
                      helperText={touched["country_id"] && errors["country_id"]}
                      FormHelperTextProps={{ className: "!text-red-500" }}
                    >
                      {country?.data?.data?.map((country) => {
                        return (
                          <MenuItem value={country.id}>
                            {country.country}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </span>
                <span className="w-full">
                  <p>State*</p>
                  <FormControl fullWidth>
                    <Select
                      id="state_id"
                      onBlur={handleBlur}
                      name="state_id"
                      color="warning"
                      value={values["state_id"]}
                      size="small"
                      className="!w-full"
                      onChange={handleChange}
                      error={
                        errors["state_id"] && touched["state_id"] ? true : false
                      }
                      helperText={touched["state_id"] && errors["state_id"]}
                      FormHelperTextProps={{ className: "!text-red-500" }}
                    >
                      {state?.data?.data?.map((state) => {
                        return (
                          <MenuItem value={state.id}>{state.state}</MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </span>
                <span className="w-full">
                  <p>City*</p>
                  <FormControl fullWidth>
                    <Select
                      id="city_id"
                      onBlur={handleBlur}
                      name="city_id"
                      color="warning"
                      value={values["city_id"]}
                      size="small"
                      className="!w-full"
                      onChange={handleChange}
                      error={
                        errors["city_id"] && touched["city_id"] ? true : false
                      }
                      helperText={touched["city_id"] && errors["city_id"]}
                      FormHelperTextProps={{ className: "!text-red-500" }}
                    >
                      {city?.data?.data?.map((city) => {
                        return <MenuItem value={city.id}>{city.city}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </span>
              </div>
              <span className="flex justify-center py-5">
                <Button
                  disableElevation
                  variant="contained"
                  type="submit"
                  className="!px-5"
                >
                  Submit
                </Button>
              </span>
            </form>
          </Drawer>
        </div>
      </div>
    </>
  );
};
export default MyBillingDetails;
